export const DefaultPageInfo = {
  itemsPerPage: 10,
  pageNumber: 1,
  totalItems: 0
};
